import React, { useState } from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import Login from '../../Components/Login/Login'
import SignUp from '../../Components/SignUp/SignUp'
import './Auth.css'



export default function Auth() {
    const [SignIn, setSignIn] = useState(false)
    return (
      <div className='Auth' >
        <Navbar colorLeft = "#5f2c3e" colorRight = "#fae5df" />
        {
          SignIn ? <Login setSignIn={setSignIn} /> : <SignUp setSignIn={setSignIn} />
        }
        
    </div>
  )
}
